import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
})
export class PasswordInputComponent extends FieldType {
  constructor() {
    super();
  }

  @ViewChild(MatInput, { static: false })
  formFieldControl: MatInput;

  @ViewChild('passwordField', { static: false }) passwordField: ElementRef;

  icon = 'visibility_off';
  inputType = 'password';

  visibilityToggle() {
    this.inputType = this.inputType === 'password' ? 'text' : 'password';
    this.icon = this.inputType === 'password' ? 'visibility_off' : 'visibility';
  }
}
